import { useApplicationContext } from '../../utils/applicationContext';

// TODO: Удалить релизный фича-флаг в CD-292428.
/* istanbul ignore next */
export const useOfferBookingFormModalEnabled = () => {
  const { config } = useApplicationContext();

  return config.get<boolean>('newbuildingBroker.offerBookingFormModalEnabled') ?? false;
};
